var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import sort, { stringSort_depricated } from "@domains/utils/sort";
import { MUTUAL_FUNDS_CLEAR_SCHEMES_DATA, MUTUAL_FUNDS_SCHEMES, MUTUAL_FUNDS_SCHEMES_APPLY_SORT, MUTUAL_FUNDS_SCHEMES_CLEAR_MSG, MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA, MUTUAL_FUNDS_SCHEMES_CLEAR_SORT, MUTUAL_FUNDS_SCHEMES_ERROR, MUTUAL_FUNDS_SCHEMES_HIDE_ERROR, MUTUAL_FUNDS_SCHEMES_PARAMS, MUTUAL_FUNDS_SCHEMES_START_LOADER, MUTUAL_FUNDS_SCHEMES_STOP_LOADER, MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER, MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER, MUTUAL_FUNDS_SCHEMES_UPDATE, MUTUAL_FUNDS_SCHEMES_UPDATE_MSG, MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA, } from "../interface/iMutualFundsSchemes";
var initState = {
    mutualFundsSchemeList: [],
    paramsData: {},
    mutualFundsLoader: false,
    mutualFundsTableLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: null,
        show: false,
        icon: null,
    },
    searchState: {
        searchData: "",
    },
    sortData: {
        sortState: [],
        sortRecord: {},
    },
    updateData: [],
    totalPages: undefined,
};
var applySorting = function (sortRecord, data, sortData) {
    if (sortRecord.type && sortRecord.type === "string") {
        data = stringSort_depricated(data, sortRecord.key, sortRecord.order);
    }
    else {
        data = sort(data, sortRecord.key, sortRecord.order);
    }
    return { sortState: sortData, sortRecord: sortRecord, data: data };
};
var mutualFundsSchemes = function (state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case MUTUAL_FUNDS_SCHEMES:
            return __assign(__assign({}, state), { mutualFundsSchemeList: action.payload.mutualFundsSchemes, totalPages: action.payload.totalPages });
        case MUTUAL_FUNDS_SCHEMES_UPDATE:
            return __assign(__assign({}, state), { mutualFundsSchemeList: __spreadArray(__spreadArray([], __read(state.mutualFundsSchemeList), false), __read(action.payload.mutualFundsSchemes), false) });
        case MUTUAL_FUNDS_SCHEMES_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case MUTUAL_FUNDS_SCHEMES_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initState.errorData });
        case MUTUAL_FUNDS_SCHEMES_PARAMS:
            return __assign(__assign({}, state), { paramsData: (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.paramsData });
        case MUTUAL_FUNDS_SCHEMES_APPLY_SORT:
            return __assign(__assign({}, state), { sortData: {
                    sortRecord: (_b = action.payload) === null || _b === void 0 ? void 0 : _b.sortState.sortRecord,
                    sortState: (_c = action.payload) === null || _c === void 0 ? void 0 : _c.sortState.sortState,
                }, updateData: applySorting((_d = action.payload) === null || _d === void 0 ? void 0 : _d.sortState.sortRecord, (_e = action.payload) === null || _e === void 0 ? void 0 : _e.updatedData, (_f = action.payload) === null || _f === void 0 ? void 0 : _f.sortState.sortState).data });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_SORT:
            return __assign(__assign({}, state), { sortData: initState.sortData, updateData: initState.updateData });
        case MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA:
            return __assign(__assign({}, state), { searchState: action.payload.searchState, updateData: action.payload.updatedData });
        case MUTUAL_FUNDS_SCHEMES_UPDATE_MSG:
            return __assign(__assign({}, state), { message: action.payload.message });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_MSG:
            return __assign(__assign({}, state), { message: initState.message });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA:
            return __assign(__assign({}, state), { searchState: initState.searchState, updateData: initState.updateData });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_MSG:
            return __assign(__assign({}, state), { message: initState.message });
        case MUTUAL_FUNDS_SCHEMES_START_LOADER:
            return __assign(__assign({}, state), { mutualFundsLoader: true });
        case MUTUAL_FUNDS_SCHEMES_STOP_LOADER:
            return __assign(__assign({}, state), { mutualFundsLoader: false });
        case MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER:
            return __assign(__assign({}, state), { mutualFundsTableLoader: true });
        case MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER:
            return __assign(__assign({}, state), { mutualFundsTableLoader: false });
        case MUTUAL_FUNDS_CLEAR_SCHEMES_DATA:
            return __assign({}, JSON.parse(JSON.stringify(initState)));
        default:
            return __assign({}, state);
    }
};
export default mutualFundsSchemes;
